// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectClosePositionMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_CLOSE_POSITION)
    this.OrderWasManual = false
    this.Id = null
    this.CloseOrderId = null
    this.ClosePrice = 0
    this.CloseTime = null
    this.Symbol = ''
    // для BT
    this.Pnl = 0
    this.Commission = 0
}

DirectClosePositionMessage.prototype = Object.create(DirectMessageBase.prototype)